var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-exception"},[_c('div',{staticClass:"app-exception__img app-exception__img--404"}),_c('h1',[_vm._v("404")]),_c('p',[_vm._v("抱歉，你访问的页面不存在")])])
}]

export { render, staticRenderFns }